import React, { useState } from 'react';
import { MegaphoneIcon, Loader2Icon, CopyIcon, SparklesIcon, FacebookIcon, InstagramIcon, VideoIcon, ImageIcon } from 'lucide-react';
export function AdCopyEngine() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const [platform, setPlatform] = useState('meta');
  const [count, setCount] = useState('5');
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2500);
  };
  const adConcepts = [{
    id: 1,
    hook: 'El error #1 que cometen las reposteras desde casa (y cómo te está costando dinero).',
    body: "Si vendes postres caseros y a fin de mes sientes que solo trabajaste para comprar más ingredientes, necesitas leer esto. El problema no es que tus postres sean malos, el problema es que estás calculando tus precios 'al ojo'. Descubre el Método Porción-Rentable™ y asegura un 60% de ganancia en cada entrega.",
    headline: 'De Repostera Cansada a Negocio Rentable 🍰',
    cta: 'Descargar Guía Ahora',
    visual: 'Video estilo POV. La creadora mostrando un cuaderno lleno de tachones intentando calcular precios, luego transición a una tabla de Excel simple y sonriendo mientras empaca un pedido hermoso.',
    prompt: 'A close up shot of a beautiful homemade chocolate cake slice in a premium clear plastic container, aesthetic lighting, instagram style food photography --ar 4:5'
  }, {
    id: 2,
    hook: 'POV: Por fin dejaste de regalar tu trabajo y ahora tus postres sí dejan ganancia real. ✨',
    body: 'Pasé meses sintiendo que trabajaba de gratis hasta que implementé este sistema de costeo simple. No necesitas ser experta en finanzas, solo necesitas la fórmula correcta. Toca el enlace para aprender cómo hacerlo en tu negocio desde casa.',
    headline: 'Aprende a cobrar lo justo por tus postres',
    cta: 'Ver Más',
    visual: "Carrusel de imágenes. Slide 1: Foto de un postre increíble con texto '¿Cuánto cobrarías por esto?'. Slide 2: Desglose visual de costos reales vs precio de venta. Slide 3: Mockup de la guía.",
    prompt: "A flat lay photo of baking ingredients (flour, eggs, chocolate) next to a calculator and a notebook with 'Profit' written on it, bright natural lighting, modern kitchen background --ar 1:1"
  }];
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-54">
      <div data-id="element-55">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-56">
          Motor de Ads (Ad Copy Engine)
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-57">
          Genera conceptos completos de anuncios para Meta y TikTok listos para
          lanzar.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-58">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-59">
          <div className="space-y-4" data-id="element-60">
            <label className="block text-sm font-medium text-slate-700" data-id="element-61">
              Plataforma Destino
            </label>
            <div className="flex gap-4" data-id="element-62">
              <button onClick={() => setPlatform('meta')} className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all ${platform === 'meta' ? 'border-indigo-600 bg-indigo-50 text-indigo-700 font-semibold' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-63">
                <FacebookIcon className="w-5 h-5" data-id="element-64" /> Meta (FB/IG)
              </button>
              <button onClick={() => setPlatform('tiktok')} className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all ${platform === 'tiktok' ? 'border-black bg-slate-100 text-black font-semibold' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-65">
                <VideoIcon className="w-5 h-5" data-id="element-66" /> TikTok
              </button>
            </div>
          </div>

          <div className="space-y-4" data-id="element-67">
            <label className="block text-sm font-medium text-slate-700" data-id="element-68">
              Cantidad de Conceptos
            </label>
            <div className="flex gap-4" data-id="element-69">
              {['5', '10', '20'].map(num => <button key={num} onClick={() => setCount(num)} className={`flex-1 py-3 px-4 rounded-xl border-2 transition-all ${count === num ? 'border-indigo-600 bg-indigo-50 text-indigo-700 font-semibold' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`} data-id="element-70">
                  {num} Ads
                </button>)}
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end pt-6 border-t border-slate-100" data-id="element-71">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-72">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-73" /> Generando
                Conceptos...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-74" /> Generar {count} Ads
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-75">
          <div className="flex items-center justify-between" data-id="element-76">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-77">
              Conceptos Generados ({platform === 'meta' ? 'Meta Ads' : 'TikTok'}
              )
            </h2>
            <span className="bg-indigo-100 text-indigo-800 text-xs font-semibold px-2.5 py-0.5 rounded-full" data-id="element-78">
              Score Promedio: 88/100
            </span>
          </div>

          <div className="grid grid-cols-1 gap-6" data-id="element-79">
            {adConcepts.map(ad => <div key={ad.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-80">
                <div className="bg-slate-50 border-b border-slate-200 p-4 flex items-center justify-between" data-id="element-81">
                  <h3 className="font-semibold text-slate-800" data-id="element-82">
                    Concepto #{ad.id}: {ad.headline.substring(0, 30)}...
                  </h3>
                  <button className="text-slate-500 hover:text-indigo-600 flex items-center gap-1 text-sm font-medium transition-colors" data-id="element-83">
                    <CopyIcon className="w-4 h-4" data-id="element-84" /> Copiar Todo
                  </button>
                </div>

                <div className="p-6 grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-85">
                  <div className="lg:col-span-2 space-y-4" data-id="element-86">
                    <div data-id="element-87">
                      <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider" data-id="element-88">
                        Hook (Gancho)
                      </span>
                      <p className="text-slate-900 font-medium mt-1 text-lg" data-id="element-89">
                        "{ad.hook}"
                      </p>
                    </div>
                    <div data-id="element-90">
                      <span className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-91">
                        Body Copy
                      </span>
                      <p className="text-slate-700 mt-1 whitespace-pre-wrap" data-id="element-92">
                        {ad.body}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-4 pt-2" data-id="element-93">
                      <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-94">
                        <span className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1" data-id="element-95">
                          Headline
                        </span>
                        <p className="text-slate-900 font-medium" data-id="element-96">
                          {ad.headline}
                        </p>
                      </div>
                      <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-97">
                        <span className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1" data-id="element-98">
                          Call to Action
                        </span>
                        <p className="text-slate-900 font-medium" data-id="element-99">{ad.cta}</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-indigo-50/50 p-5 rounded-xl border border-indigo-100 space-y-4" data-id="element-100">
                    <div data-id="element-101">
                      <span className="flex items-center gap-1.5 text-xs font-bold text-indigo-800 uppercase tracking-wider mb-2" data-id="element-102">
                        <VideoIcon className="w-4 h-4" data-id="element-103" /> Concepto Visual
                      </span>
                      <p className="text-sm text-indigo-900" data-id="element-104">{ad.visual}</p>
                    </div>
                    <div className="pt-4 border-t border-indigo-100" data-id="element-105">
                      <span className="flex items-center gap-1.5 text-xs font-bold text-indigo-800 uppercase tracking-wider mb-2" data-id="element-106">
                        <ImageIcon className="w-4 h-4" data-id="element-107" /> Prompt Midjourney
                      </span>
                      <p className="text-xs text-slate-600 font-mono bg-white p-2 rounded border border-indigo-100" data-id="element-108">
                        {ad.prompt}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>}
    </div>;
}